import { ENV_CONFIG } from './env';

export interface ContactDetails {
    email: string;
    phone: string;
    address: {
        street: string;
        city: string;
        state: string;
        zip: string;
        full: string;
    };
    company: {
        name: string;
        longName: string;
        legalName: string;
    };
    support: {
        email: string;
        phone: string;
    };
    legal: {
        email: string;
    };
    privacy: {
        email: string;
    };
}

export const CONTACT_DETAILS: ContactDetails = {
    email: ENV_CONFIG.contact.email,
    phone: ENV_CONFIG.contact.phone,
    address: {
        street: ENV_CONFIG.address.street,
        city: ENV_CONFIG.address.city,
        state: ENV_CONFIG.address.state,
        zip: ENV_CONFIG.address.zip,
        full: ENV_CONFIG.address.full,
    },
    company: {
        name: ENV_CONFIG.company.name,
        longName: ENV_CONFIG.company.longName,
        legalName: ENV_CONFIG.company.legalName,
    },
    support: {
        email: ENV_CONFIG.emails.support,
        phone: ENV_CONFIG.contact.phone,
    },
    legal: {
        email: ENV_CONFIG.emails.legal,
    },
    privacy: {
        email: ENV_CONFIG.emails.privacy,
    },
};

// Export the environment config for direct access if needed
export { ENV_CONFIG };